import { useMobile } from 'src/hooks/useMobile';
import { BracketColumnsStack } from './BracketColumnsStack';
import { MatchProps } from '../match/MatchProvider';
import { Round } from 'functions/src/types/firestore/Game/Tournament/Bracket';
import { useGenerateBracket } from 'src/hooks/useGenerateBracket';

export const CONNECTORS = {
  ['5-mobile']: { width: 668, height: 1438, size: 32 },
  ['4-mobile']: { width: 456, height: 672, size: 16 },
  ['3-mobile']: { width: 244, height: 292, size: 8 },
  ['2-mobile']: { width: 32, height: 118, size: 4 },
  ['5']: { width: 1072, height: 672, size: 32 },
  ['4']: { width: 648, height: 664, size: 16 },
  ['3']: { width: 224, height: 442, size: 8 },
  ['2']: { width: 118, height: 270, size: 4 },
};

export type BracketProps = {
  rounds: Round<Date>[];
  Match: (props: MatchProps) => JSX.Element;
};

export function Bracket({ rounds, Match }: BracketProps) {
  const isMobile = useMobile();
  const {
    mobileColumns,
    matchColumnsLeft,
    matchColumnCenter,
    matchColumnsRight,
  } = useGenerateBracket(rounds, Match);

  const connectorSx =
    CONNECTORS[`${rounds.length}${isMobile ? '-mobile' : ''}`];

  return (
    <BracketColumnsStack connectorSx={connectorSx}>
      {isMobile
        ? mobileColumns
        : [matchColumnsLeft, matchColumnCenter, matchColumnsRight]}
    </BracketColumnsStack>
  );
}
